import {MSP} from "./msp";
import {onMount} from "@otto-ec/global-resources/dom";

onMount(".promo-msp__container", (element) => {
    new MSP(element);
});